import { Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useFindAllDepartmentMasterMutation, useGetDepartmentMasterByIdMutation, useSaveDepartmentMasterMutation, useUpdateDepartmentMasterMutation } from "../../redux-toolkit/services/departmentMasterService";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { Button, Checkbox, Col, DatePicker, Input, Radio, Row, Select, Space, Table } from "antd";
import { useFindAllOrganizationMasterMutation } from "../../redux-toolkit/services/organizationMasterService";
import { allOrganizationMasterDetails, setAllOrganizationMaster } from "../../redux-toolkit/slices/organizationMasterSlice";
import { allDepartmentMasterDetails, setAllDepartmentMaster } from "../../redux-toolkit/slices/departmentMasterSlice";
import { useFindAllProjectMasterMutation, useGetProjectMasterByIdMutation, useSaveProjectMasterMutation, useUpdateProjectMasterMutation } from "../../redux-toolkit/services/projectMasterService";
import dayjs, { Dayjs } from 'dayjs';
import { useFindAllProjectTypeMasterMutation, useGetProjectTypeMasterByIdMutation, useSaveProjectTypeMasterMutation, useUpdateProjectTypeMasterMutation } from "../../redux-toolkit/services/projectTypeMasterService";
import { useFindAllPhaseMasterMutation, useGetPhaseMasterByIdMutation, useSavePhaseMasterMutation, useUpdatePhaseMasterMutation } from "../../redux-toolkit/services/phaseMasterService";
import { allProjectTypeMasterDetails, setAllProjectTypeMaster } from "../../redux-toolkit/slices/projectTypeMasterSlice";
import { allPhaseMasterDetails, setAllPhaseMaster } from "../../redux-toolkit/slices/phaseMasterSlice";
import { useGetProjectUserMasterByIdMutation, useSaveProjectUserMasterMutation, useUpdateProjectUserMasterMutation } from "../../redux-toolkit/services/projectUserMasterService";
import { useFindAllProjectPhaseActivityMutation, useGetProjectPhaseActivityByIdMutation, useSaveProjectPhaseActivityMutation, useUpdateProjectPhaseActivityMutation } from "../../redux-toolkit/services/projectPhaseActivityService";
import { useFindAllRoleMasterMutation } from "../../redux-toolkit/services/userRoleService";
import { getAllUserRoleDetails, setAllUserRole } from "../../redux-toolkit/slices/allUserRoleSlice";
import { allProjectMasterDetails, setAllProjectMaster } from "../../redux-toolkit/slices/projectMasterSlice";
import { PROJECTIVITY_STATUS } from "../../constant/AppConstant";
import * as Yup from 'yup';
import { useFindAllUsersMutation, useGetUserByGroupIdMutation } from "../../redux-toolkit/services/allUserService";
import { getAllUserDetails, getFindUserByGroupIdDetails, setAllUser, setUserByGroupId } from "../../redux-toolkit/slices/allUserSlice";
import { useGetAllUserGroupMutation } from "../../redux-toolkit/services/userGroupService";
import { getAllUserGroupDetails, setAllUserGroup } from "../../redux-toolkit/slices/allUserGroupSlice";
import { useFindAllKRAMasterMutation, useGetKRAMasterByIdMutation, useSaveKRAMasterMutation, useUpdateKRAMasterMutation } from "../../redux-toolkit/services/kRAMasterService";
import { allKRAMasterDetails, setAllKRAMaster } from "../../redux-toolkit/slices/kRAMasterSlice";
import { format } from "date-fns";
import { allProjectPhaseActivityDetails, setAllProjectPhaseActivity } from "../../redux-toolkit/slices/projectPhaseActivitySlice";
import { BsDashCircle, BsPlusCircle } from "react-icons/bs";
import { useGetTimeSheetByIdMutation, useSaveTimeSheetMutation, useUpdateTimeSheetMutation } from "../../redux-toolkit/services/timeSheetService";
import { allTimeSheetDetails } from "../../redux-toolkit/slices/timeSheetSlice";
import TimeSheetGraph from "../TimeSheetGraph";

const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        // .required('Percentage is required')
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const MasterReportData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [fileName, setFileName]: any = useState("");
    const [dataSource, setDataSource]: any = useState([]);
    const [filteredPhase, setFilteredPhase]: any = useState([]);
    const [showGrid, setShowGrid] = useState(false);
    const [gridData, setGridData] = useState([]); // State to store the user data
    const [showTimeSheetGrid, setShowTimeSheetGrid] = useState(false);
    const [isMentorMatched, setIsMentorMatched] = useState(false);
    const [timeSheetApproved, setTimeSheetApproved] = useState<string | null>(null);
    // const [dateRange, setDateRange] = useState<string[]>([]);
    const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null] | null>(null);
    const [timeSheetData, setTimeSheetData] = useState<any[]>([]);

    //save
    const [saveDepartmentMaster, saveDepartmentMasterResponse] = useSaveDepartmentMasterMutation();
    const [saveProjectMaster, saveProjectMasterResponse] = useSaveProjectMasterMutation();
    const [saveProjectTypeMaster, saveProjectTypeMasterResponse] = useSaveProjectTypeMasterMutation();
    const [savePhaseMaster, savePhaseMasterResponse] = useSavePhaseMasterMutation();
    const [saveProjectUserMaster, saveProjectUserMasterResponse] = useSaveProjectUserMasterMutation();
    const [saveProjectPhaseActivity, saveProjectPhaseActivityResponse] = useSaveProjectPhaseActivityMutation();
    const [saveKRAMaster, saveKRAMasterRespone] = useSaveKRAMasterMutation();
    const [saveTimeSheet, saveTimeSheetResponse] = useSaveTimeSheetMutation();

    //update
    const [updateDepartmentMaster, updateDepartmentMasterResponse] = useUpdateDepartmentMasterMutation();
    const [updateProjectMaster, updateProjectMasterResponse] = useUpdateProjectMasterMutation();
    const [updateProjectTypeMaster, updateProjectTypeMasterResponse] = useUpdateProjectTypeMasterMutation();
    const [updatePhaseMaster, updatePhaseMasterResponse] = useUpdatePhaseMasterMutation();
    const [updateProjectUserMaster, updateProjectUserMasterResponse] = useUpdateProjectUserMasterMutation();
    const [updateProjectPhaseActivity, updateProjectPhaseActivityResponse] = useUpdateProjectPhaseActivityMutation();
    const [updpateKRAMaster, updpateKRAMasterResponse] = useUpdateKRAMasterMutation();
    const [updateTimeSheet, updateTimeSheetResponse] = useUpdateTimeSheetMutation();

    //getById mutation
    const [getDepartmentMasterById, getDepartmentMasterByIdResponse] = useGetDepartmentMasterByIdMutation();
    const [getProjectMasterById, getProjectMasterByIdResponse] = useGetProjectMasterByIdMutation();
    const [getProjectTypeMasterById, getProjectTypeMasterByIdResponse] = useGetProjectTypeMasterByIdMutation();
    const [getPhaseMasterById, getPhaseMasterByIdResponse] = useGetPhaseMasterByIdMutation();
    const [getProjectUserMasterById, getProjectUserMasterByIdResponse] = useGetProjectUserMasterByIdMutation();
    const [getProjectPhaseActivityById, getProjectPhaseActivityByIdResponse] = useGetProjectPhaseActivityByIdMutation();
    const [getKRAMasterById, getKRAMasterByIdResponse] = useGetKRAMasterByIdMutation();
    const [getTimeSheetById, getTimeSheetByIdResponse] = useGetTimeSheetByIdMutation();

    //getData
    const [findAllDepartmentMaster, findAllDepartmentMasterResponse] = useFindAllDepartmentMasterMutation();
    const [findAllProjectTypeMaster, findAllProjectTypeMasterResponse] = useFindAllProjectTypeMasterMutation();
    const [findAllPhaseMaster, findAllPhaseMasterResponse] = useFindAllPhaseMasterMutation();
    const [getAllOrganizations, allOrganizationsResponse] = useFindAllOrganizationMasterMutation();
    const [getAllUserGroup, allUserGroupRespone] = useGetAllUserGroupMutation();
    const [getAllUserRole, allUserRoleRespone] = useFindAllRoleMasterMutation();
    const [findAllProjectMaster, findAllProjectMasterResponse] = useFindAllProjectMasterMutation();
    const [findAllUsers, findAllUsersResponse] = useFindAllUsersMutation();
    const [findUserByGroupId, userByGroupIdResponse] = useGetUserByGroupIdMutation();
    const [findAllKRAMaster, findAllKRAMasterResponse] = useFindAllKRAMasterMutation();
    const [findAllProjectPhaseActivity, findAllProjectPhaseActivityRes] = useFindAllProjectPhaseActivityMutation();

    //Data
    const allDepartmentMasters: any = useAppSelector(allDepartmentMasterDetails);
    const organizationData: any = useAppSelector(allOrganizationMasterDetails);
    const allProjectMasterData: any = useAppSelector(allProjectMasterDetails);
    const allProjectTypeMasterData: any = useAppSelector(allProjectTypeMasterDetails);
    const allPhaseMasterData: any = useAppSelector(allPhaseMasterDetails);
    const allUserGroupData: any = useAppSelector(getAllUserGroupDetails);
    const allUserRoleData: any = useAppSelector(getAllUserRoleDetails);
    const allUsersData: any = useAppSelector(getAllUserDetails);
    const usersByGroupData: any = useAppSelector(getFindUserByGroupIdDetails);
    const allKRAMasterData: any = useAppSelector(allKRAMasterDetails);
    const allProjectPhaseActivityData: any = useAppSelector(allProjectPhaseActivityDetails);
    const allTimeSheetData: any = useAppSelector(allTimeSheetDetails);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {

            if (props.reportName === REPORT_NAME.DEPARTMENT_MASTER) {
                getAllOrganizations({ token: localUserObj.token })
                getDepartmentMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

            } else if (props.reportName === REPORT_NAME.PROJECT_MASTER) {
                getAllOrganizations({ token: localUserObj.token })
                findAllDepartmentMaster({ token: localUserObj.token })
                findAllProjectTypeMaster({ token: localUserObj.token })
                findAllPhaseMaster({ token: localUserObj.token })
                getProjectMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

            } else if (props.reportName === REPORT_NAME.PROJECT_USER_MASTER) {
                getProjectUserMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllUserGroup({ token: localUserObj.token });
                getAllUserRole({ token: localUserObj.token });
                findAllProjectMaster({ token: localUserObj.token });
            } else if (props.reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {
                getProjectTypeMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

            } else if (props.reportName === REPORT_NAME.PHASE_MASTER) {
                getPhaseMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
                getProjectPhaseActivityById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                findAllProjectMaster({ token: localUserObj.token });
                findAllProjectTypeMaster({ token: localUserObj.token });
                findAllPhaseMaster({ token: localUserObj.token });
                findAllUsers({ token: localUserObj.token });
                findAllKRAMaster({ token: localUserObj.token });
            } else if (props.reportName === REPORT_NAME.KRA_MASTER) {
                getKRAMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.TIME_SHEET) {
                findAllProjectMaster({ token: localUserObj.token });
                findAllKRAMaster({ token: localUserObj.token });
                findAllProjectPhaseActivity({ token: localUserObj.token });
                getTimeSheetById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.DEPARTMENT_MASTER) {
                getAllOrganizations({ token: localUserObj.token });

            } else if (props.reportName === REPORT_NAME.PROJECT_MASTER) {
                getAllOrganizations({ token: localUserObj.token });
                findAllDepartmentMaster({ token: localUserObj.token });
                findAllProjectTypeMaster({ token: localUserObj.token });
                findAllPhaseMaster({ token: localUserObj.token });

            } else if (props.reportName === REPORT_NAME.PROJECT_USER_MASTER) {
                getAllUserGroup({ token: localUserObj.token });
                getAllUserRole({ token: localUserObj.token });
                findAllProjectMaster({ token: localUserObj.token });

            } else if (props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {
                findAllProjectMaster({ token: localUserObj.token });
                findAllProjectTypeMaster({ token: localUserObj.token });
                findAllPhaseMaster({ token: localUserObj.token });
                findAllUsers({ token: localUserObj.token });
                findAllKRAMaster({ token: localUserObj.token });
            } else if (props.reportName === REPORT_NAME.TIME_SHEET) {
                findAllProjectMaster({ token: localUserObj.token });
                findAllKRAMaster({ token: localUserObj.token });
                findAllProjectPhaseActivity({ token: localUserObj.token });
            }
        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };

    const normalizeToArray = (input: string | string[] | undefined) => {
        if (Array.isArray(input)) {
            // If already an array, return as is
            return input;
        } else if (typeof input === 'string') {
            // If a comma-separated string, split and trim
            return input.split(',').map((value) => value.trim());
        }
        // If undefined or any other type, return an empty array
        return [];
    };

    const handleSubmit = (values: any) => {

        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.DEPARTMENT_MASTER) {

                const orgObj = organizationData && organizationData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.orgId);
                    });

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                    orgId: parseInt(values.orgId),
                    orgName: orgObj.name,
                }

                saveDepartmentMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_MASTER) {

                const orgObj = organizationData && organizationData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.orgId);
                    });

                const departmentObj = allDepartmentMasters && allDepartmentMasters
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.departmentId);
                    });

                const projectTypeObj = allProjectTypeMasterData && allProjectTypeMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectTypeId);
                    });

                const filteredPhaseNames = allPhaseMasterData
                    .filter((phase: any) => (values.phaseId).includes(phase.id))  // Filter phases based on selectedPhase
                    .map((phase: any) => phase.name);

                const projectMentorsArray = normalizeToArray(values.projectMentors);
                const projectMembersArray = normalizeToArray(values.projectMembers);

                // const projectMentorsArray = values.projectMentors ? (values.projectMentors).split(',').map((value: any) => value.trim()) : [];
                // const projectMembersArray = values.projectMembers ? (values.projectMembers).split(',').map((value: any) => value.trim()) : [];

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                    description: values.description,
                    departmentId: values.departmentId ? parseInt(values.departmentId) : "",
                    departmentName: departmentObj.name ? departmentObj.name : "",
                    orgId: values.orgId ? parseInt(values.orgId) : "",
                    orgName: orgObj.name ? orgObj.name : "",
                    projectTypeId: values.projectTypeId ? parseInt(values.projectTypeId) : "",
                    projectTypeName: projectTypeObj.name ? projectTypeObj.name : "",
                    sponsor: values.sponsor,
                    participatingOrganization: values.participatingOrganization,
                    mentors: projectMentorsArray,
                    members: projectMembersArray,
                    // phase: filteredPhaseNames,
                    phase: values.phaseId,
                    problem: values.problem,
                    solution: values.solution,
                    aiComponent: values.aiComponent,
                    aiComponentDescription: values.aiComponentDescription,
                    socialImpact: values.socialImpact,
                    planStarted: values.planStarted,
                    planEnded: values.planEnded,
                }

                saveProjectMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                }

                saveProjectTypeMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.PHASE_MASTER) {

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                }

                savePhaseMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_USER_MASTER) {

                //Todo change values.-----
                const projectObj = allProjectMasterData && allProjectMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectId);
                    });

                // const userRoleObj = allUserRoleData && allUserRoleData
                //     .find((item: any) => {
                //         return parseInt(item.id) === parseInt(values.userRoleId);
                //     });

                const userGroupObj = allUserGroupData && allUserGroupData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.userGroupId);
                    });

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                    projectId: values.projectId,
                    projectName: projectObj.name,
                    // userRoleId: values.userRoleId,
                    // userRoleName: userRoleObj.name,
                    userGroupId: values.userGroupId,
                    userGroupName: userGroupObj.name,
                    mappingDTO: gridData ? gridData : []
                }

                saveProjectUserMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {

                const projectObj = allProjectMasterData && allProjectMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectMasterId);
                    });

                const projectTypeObj = allProjectTypeMasterData && allProjectTypeMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectTypeId);
                    });

                const taskOwnerObj = allUsersData && allUsersData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.taskOwner);
                    });

                const issueOwnerObj = allUsersData && allUsersData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.issueOwner);
                    });

                const selectedPhaseData = allPhaseMasterData
                    .filter((phase: any) => (values.phaseId).includes(phase.id)) // Filter phases by selected IDs
                    .map((phase: any) => ({
                        phaseId: phase.id,
                        phaseName: phase.name
                    }));

                const kraMasterObj = allKRAMasterData && allKRAMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.kraMasterId);
                    });

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                    activityDescription: values.activityDescription,
                    projectCode: values.projectCode,
                    activityCode: values.activityCode,
                    projectId: values.projectMasterId,
                    projectName: projectObj.name,
                    projectTypeId: values.projectTypeId,
                    projectTypeName: projectTypeObj.name,
                    // phaseId: values.phaseId ? values.phaseId : [],
                    phases: selectedPhaseData,
                    userId: localUserObj && localUserObj?.id,
                    planStartDate: values.planStarted,
                    planEndDate: values.planEnded,
                    actualStartDate: values.actualStartDate,
                    actualEndDate: values.actualEndDate,
                    expectedDeliverable: values.expectedDeliverable,
                    issue: values.issue,
                    risk: values.risk,
                    issueOwner: issueOwnerObj.username,
                    issueOwnerId: parseInt(values.issueOwner),
                    issueOwnerEmail: issueOwnerObj.email,
                    taskOwner: taskOwnerObj.username,
                    taskOwnerEmail: taskOwnerObj.email,
                    taskOwnerId: parseInt(values.taskOwner),
                    documentPath: values.documentPath,
                    projectStatus: values.projectStatus,
                    percentageCompleted: values.percentageCompleted,
                    kraMasterId: values.kraMasterId,
                    kraMasterName: kraMasterObj.name
                }

                saveProjectPhaseActivity({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.KRA_MASTER) {

                const payload = {
                    status: true,
                    id: 0,
                    name: values.name,
                }

                saveKRAMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.TIME_SHEET) {

                console.log(timeSheetData)

                const payload = {
                    status: true,
                    id: 0,
                    userId: localUserObj?.id,
                    userName: localUserObj?.username,
                    entriesDTOS: timeSheetData ? timeSheetData : [],
                    isApproved: timeSheetApproved,
                    // isApproved: "No",
                }
                console.log(payload)

                saveTimeSheet({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.DEPARTMENT_MASTER) {

                const orgObj = organizationData && organizationData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.orgId);
                    });

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                    orgId: parseInt(values.orgId),
                    orgName: orgObj.name,
                }

                updateDepartmentMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_MASTER) {

                const orgObj = organizationData && organizationData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.orgId);
                    });

                const departmentObj = allDepartmentMasters && allDepartmentMasters
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.departmentId);
                    });

                const projectTypeObj = allProjectTypeMasterData && allProjectTypeMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectTypeId);
                    });

                const filteredPhaseNames = allPhaseMasterData
                    .filter((phase: any) => (values.phaseId).includes(phase.id))  // Filter phases based on selectedPhase
                    .map((phase: any) => phase.name);

                const projectMentorsArray = normalizeToArray(values.projectMentors);
                const projectMembersArray = normalizeToArray(values.projectMembers);

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                    description: values.description,
                    departmentId: values.departmentId ? parseInt(values.departmentId) : "",
                    departmentName: departmentObj.name ? departmentObj.name : "",
                    orgId: values.orgId ? parseInt(values.orgId) : "",
                    orgName: orgObj.name ? orgObj.name : "",
                    projectTypeId: values.projectTypeId ? parseInt(values.projectTypeId) : "",
                    projectTypeName: projectTypeObj.name ? projectTypeObj.name : "",
                    sponsor: values.sponsor,
                    participatingOrganization: values.participatingOrganization,
                    mentors: projectMentorsArray,
                    members: projectMembersArray,
                    // phase: filteredPhaseNames,
                    phase: values.phaseId,
                    problem: values.problem,
                    solution: values.solution,
                    aiComponent: values.aiComponent,
                    aiComponentDescription: values.aiComponentDescription,
                    socialImpact: values.socialImpact,
                    planStarted: values.planStarted,
                    planEnded: values.planEnded,
                }

                updateProjectMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_TYPE_MASTER) {

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                }

                updateProjectTypeMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.PHASE_MASTER) {

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                }

                updatePhaseMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_USER_MASTER) {

                const projectObj = allProjectMasterData && allProjectMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectId);
                    });

                // const userRoleObj = allUserRoleData && allUserRoleData
                //     .find((item: any) => {
                //         return parseInt(item.id) === parseInt(values.userRoleId);
                //     });

                const userGroupObj = allUserGroupData && allUserGroupData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.userGroupId);
                    });

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                    projectId: values.projectTypeId,
                    projectName: projectObj.name,
                    // userRoleId: values.userRoleId,
                    // userRoleName: userRoleObj.name,
                    userGroupId: values.userGroupId,
                    userGroupName: userGroupObj.name,
                    mappingDTO: gridData ? gridData : []
                }

                updateProjectUserMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY) {

                const projectObj = allProjectMasterData && allProjectMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectMasterId);
                    });

                const projectTypeObj = allProjectTypeMasterData && allProjectTypeMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.projectTypeId);
                    });

                const taskOwnerObj = allUsersData && allUsersData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.taskOwner);
                    });

                const kraMasterObj = allKRAMasterData && allKRAMasterData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.kraMasterId);
                    });

                const issueOwnerObj = allUsersData && allUsersData
                    .find((item: any) => {
                        return parseInt(item.id) === parseInt(values.issueOwner);
                    });

                const selectedPhaseData = allPhaseMasterData
                    .filter((phase: any) => (values.phaseId).includes(phase.id)) // Filter phases by selected IDs
                    .map((phase: any) => ({
                        phaseId: phase.id,
                        phaseName: phase.name
                    }));

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                    activityDescription: values.activityDescription,
                    projectCode: values.projectCode,
                    activityCode: values.activityCode,
                    projectId: values.projectMasterId,
                    projectName: projectObj.name,
                    projectTypeId: values.projectTypeId,
                    projectTypeName: projectTypeObj.name,
                    phases: selectedPhaseData,
                    userId: localUserObj && localUserObj?.id,
                    planStartDate: values.planStarted,
                    planEndDate: values.planEnded,
                    actualStartDate: values.actualStartDate,
                    actualEndDate: values.actualEndDate,
                    expectedDeliverable: values.expectedDeliverable,
                    issue: values.issue,
                    risk: values.risk,
                    issueOwner: issueOwnerObj.username,
                    issueOwnerId: parseInt(values.issueOwner),
                    issueOwnerEmail: issueOwnerObj.email,
                    taskOwner: taskOwnerObj.username,
                    taskOwnerId: parseInt(values.taskOwner),
                    taskOwnerEmail: taskOwnerObj.email,
                    documentPath: values.documentPath,
                    projectStatus: values.projectStatus,
                    percentageCompleted: values.percentageCompleted,
                    kraMasterId: values.kraMasterId,
                    kraMasterName: kraMasterObj.name
                }

                updateProjectPhaseActivity({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.KRA_MASTER) {

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    name: values.name,
                }

                updpateKRAMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.TIME_SHEET) {

                const payload = {
                    status: props.data.status,
                    id: props?.data?.id,
                    userId: localUserObj?.id,
                    userName: values.userName,
                    entriesDTOS: timeSheetData ? timeSheetData : [],
                    isApproved: timeSheetApproved,
                    // isApproved: "No",
                }

                updateTimeSheet({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }
        }
    };

    //save response useEffects
    useEffect(() => {
        if (saveDepartmentMasterResponse.isSuccess) {
            alertMessage("Department master saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveDepartmentMasterResponse.isError) {
            let response: any = saveDepartmentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveDepartmentMasterResponse.isSuccess, saveDepartmentMasterResponse.isError]);

    useEffect(() => {
        if (saveProjectMasterResponse.isSuccess) {
            alertMessage("Project master saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveProjectMasterResponse.isError) {
            let response: any = saveProjectMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveProjectMasterResponse.isSuccess, saveProjectMasterResponse.isError]);

    useEffect(() => {
        if (saveProjectTypeMasterResponse.isSuccess) {
            alertMessage("Project type master saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveProjectTypeMasterResponse.isError) {
            let response: any = saveProjectTypeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveProjectTypeMasterResponse.isSuccess, saveProjectTypeMasterResponse.isError]);

    useEffect(() => {
        if (savePhaseMasterResponse.isSuccess) {
            alertMessage("Phase master saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (savePhaseMasterResponse.isError) {
            let response: any = savePhaseMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [savePhaseMasterResponse.isSuccess, savePhaseMasterResponse.isError]);

    useEffect(() => {
        if (saveProjectUserMasterResponse.isSuccess) {
            alertMessage("Project user master saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveProjectUserMasterResponse.isError) {
            let response: any = saveProjectUserMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveProjectUserMasterResponse.isSuccess, saveProjectUserMasterResponse.isError]);

    useEffect(() => {
        if (saveProjectPhaseActivityResponse.isSuccess) {
            alertMessage("Project phase activity saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveProjectPhaseActivityResponse.isError) {
            let response: any = saveProjectPhaseActivityResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveProjectPhaseActivityResponse.isSuccess, saveProjectPhaseActivityResponse.isError]);

    useEffect(() => {
        if (saveKRAMasterRespone.isSuccess) {
            alertMessage("Key result area master saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveKRAMasterRespone.isError) {
            let response: any = saveKRAMasterRespone?.error;
            alertMessage(response, "error");
        }
    }, [saveKRAMasterRespone.isSuccess, saveKRAMasterRespone.isError]);

    useEffect(() => {
        if (saveTimeSheetResponse.isSuccess) {
            alertMessage("Time sheet saved successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveTimeSheetResponse.isError) {
            let response: any = saveTimeSheetResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveTimeSheetResponse.isSuccess, saveTimeSheetResponse.isError]);

    //update response useEffects

    useEffect(() => {
        if (updateDepartmentMasterResponse.isSuccess) {
            alertMessage("Department master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateDepartmentMasterResponse.isError) {
            alertMessage("Error while updating department master", "error");
        }
    }, [updateDepartmentMasterResponse.isSuccess, updateDepartmentMasterResponse.isError]);

    useEffect(() => {
        if (updateProjectMasterResponse.isSuccess) {
            alertMessage("Project master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateProjectMasterResponse.isError) {
            alertMessage("Error while updating project master", "error");
        }
    }, [updateProjectMasterResponse.isSuccess, updateProjectMasterResponse.isError]);

    useEffect(() => {
        if (updateProjectTypeMasterResponse.isSuccess) {
            alertMessage("Project type master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateProjectTypeMasterResponse.isError) {
            alertMessage("Error while updating project type master", "error");
        }
    }, [updateProjectTypeMasterResponse.isSuccess, updateProjectTypeMasterResponse.isError]);

    useEffect(() => {
        if (updatePhaseMasterResponse.isSuccess) {
            alertMessage("Phase master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updatePhaseMasterResponse.isError) {
            alertMessage("Error while updating phase master", "error");
        }
    }, [updatePhaseMasterResponse.isSuccess, updatePhaseMasterResponse.isError]);

    useEffect(() => {
        if (updateProjectUserMasterResponse.isSuccess) {
            alertMessage("Project user master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateProjectUserMasterResponse.isError) {
            alertMessage("Error while updating project master", "error");
        }
    }, [updateProjectUserMasterResponse.isSuccess, updateProjectUserMasterResponse.isError]);

    useEffect(() => {
        if (updateProjectPhaseActivityResponse.isSuccess) {
            alertMessage("Project phase activity updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateProjectPhaseActivityResponse.isError) {
            alertMessage("Error while updating project master", "error");
        }
    }, [updateProjectPhaseActivityResponse.isSuccess, updateProjectPhaseActivityResponse.isError]);

    useEffect(() => {
        if (updpateKRAMasterResponse.isSuccess) {
            alertMessage("Key result area master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updpateKRAMasterResponse.isError) {
            alertMessage("Error while updating key result area", "error");
        }
    }, [updpateKRAMasterResponse.isSuccess, updpateKRAMasterResponse.isError]);

    useEffect(() => {
        if (updateTimeSheetResponse.isSuccess) {
            alertMessage("Time sheet updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateTimeSheetResponse.isError) {
            alertMessage("Error while updating key result area", "error");
        }
    }, [updateTimeSheetResponse.isSuccess, updateTimeSheetResponse.isError]);

    //getByIdResponse
    useEffect(() => {
        if (getDepartmentMasterByIdResponse.isSuccess) {
            setGetByIdData(getDepartmentMasterByIdResponse.data);
        } else if (getDepartmentMasterByIdResponse.isError) {
            alertMessage("Error while getting department master data", "error");
        }
    }, [getDepartmentMasterByIdResponse.isSuccess, getDepartmentMasterByIdResponse.isError]);

    useEffect(() => {
        if (getProjectMasterByIdResponse.isSuccess) {
            setGetByIdData(getProjectMasterByIdResponse.data);
        } else if (getProjectMasterByIdResponse.isError) {
            alertMessage("Error while getting project master data", "error");
        }
    }, [getProjectMasterByIdResponse.isSuccess, getProjectMasterByIdResponse.isError]);

    useEffect(() => {
        if (getProjectTypeMasterByIdResponse.isSuccess) {
            setGetByIdData(getProjectTypeMasterByIdResponse.data);
        } else if (getProjectTypeMasterByIdResponse.isError) {
            alertMessage("Error while getting project type master data", "error");
        }
    }, [getProjectTypeMasterByIdResponse.isSuccess, getProjectTypeMasterByIdResponse.isError]);

    useEffect(() => {
        if (getPhaseMasterByIdResponse.isSuccess) {
            setGetByIdData(getPhaseMasterByIdResponse.data);
        } else if (getPhaseMasterByIdResponse.isError) {
            alertMessage("Error while getting phase master data", "error");
        }
    }, [getPhaseMasterByIdResponse.isSuccess, getPhaseMasterByIdResponse.isError]);

    useEffect(() => {
        if (getProjectUserMasterByIdResponse.isSuccess) {
            setGetByIdData(getProjectUserMasterByIdResponse.data);
            setShowGrid(true);
        } else if (getProjectUserMasterByIdResponse.isError) {
            alertMessage("Error while getting project user master data", "error");
        }
    }, [getProjectUserMasterByIdResponse.isSuccess, getProjectUserMasterByIdResponse.isError]);

    useEffect(() => {
        if (getProjectPhaseActivityByIdResponse.isSuccess) {
            setGetByIdData(getProjectPhaseActivityByIdResponse.data);
        } else if (getProjectPhaseActivityByIdResponse.isError) {
            alertMessage("Error while getting project phase activity data", "error");
        }
    }, [getProjectPhaseActivityByIdResponse.isSuccess, getProjectPhaseActivityByIdResponse.isError]);

    useEffect(() => {
        if (getKRAMasterByIdResponse.isSuccess) {
            setGetByIdData(getKRAMasterByIdResponse.data);
        } else if (getKRAMasterByIdResponse.isError) {
            alertMessage("Error while getting key result area data", "error");
        }
    }, [getKRAMasterByIdResponse.isSuccess, getKRAMasterByIdResponse.isError]);

    useEffect(() => {
        if (getTimeSheetByIdResponse.isSuccess) {
            setGetByIdData(getTimeSheetByIdResponse.data);
            setTimeSheetData(getTimeSheetByIdResponse?.data?.entriesDTOS);
            // const processedData = processGraphData(getTimeSheetByIdResponse?.data?.entriesDTOS, record.project);
            // setGraphData(processedData);
            const entriesDTO = getTimeSheetByIdResponse?.data?.entriesDTOS
            if (entriesDTO && entriesDTO.length > 0) {
                // Extract dates from entriesDTO and parse them
                const validDates = entriesDTO
                    .map((entry: any) => new Date(entry.date))
                    .filter((date: any) => !isNaN(date)); // Filter out invalid dates

                if (validDates.length > 0) {
                    const minDate = new Date(Math.min(...validDates));
                    const maxDate = new Date(Math.max(...validDates));

                    // Extract only the date part (YYYY-MM-DD)
                    const minDateDayjs = dayjs(minDate);
                    const maxDateDayjs = dayjs(maxDate);

                    // Update state
                    setDateRange([minDateDayjs, maxDateDayjs]);
                    setShowTimeSheetGrid(true);
                }
            }
        } else if (getTimeSheetByIdResponse.isError) {
            alertMessage("Error while getting time sheet data", "error");
        }
    }, [getTimeSheetByIdResponse.isSuccess, getTimeSheetByIdResponse.isError]);

    //getData responses
    useEffect(() => {
        if (findAllDepartmentMasterResponse.isSuccess) {
            dispatch(setAllDepartmentMaster(findAllDepartmentMasterResponse))
        } else if (findAllDepartmentMasterResponse.isError) {
            alertMessage("Error while fetching department masters", "error");
        }
    }, [findAllDepartmentMasterResponse.isSuccess, findAllDepartmentMasterResponse.isError]);

    useEffect(() => {
        if (allOrganizationsResponse.isSuccess) {
            dispatch(setAllOrganizationMaster(allOrganizationsResponse));
        } else if (allOrganizationsResponse.isError) {
            alertMessage("Error fetching companies", "error");
        }
    }, [allOrganizationsResponse.isSuccess, allOrganizationsResponse.isError]);

    useEffect(() => {
        if (findAllProjectTypeMasterResponse.isSuccess) {
            dispatch(setAllProjectTypeMaster(findAllProjectTypeMasterResponse))
        } else if (findAllProjectTypeMasterResponse.isError) {
            alertMessage("Error while fetching department masters", "error");
        }
    }, [findAllProjectTypeMasterResponse.isSuccess, findAllProjectTypeMasterResponse.isError]);

    useEffect(() => {
        if (findAllPhaseMasterResponse.isSuccess) {
            dispatch(setAllPhaseMaster(findAllPhaseMasterResponse))
            setFilteredPhase(findAllPhaseMasterResponse.data)
        } else if (findAllPhaseMasterResponse.isError) {
            alertMessage("Error while fetching phase masters", "error");
        }
    }, [findAllPhaseMasterResponse.isSuccess, findAllPhaseMasterResponse.isError]);

    useEffect(() => {
        if (findAllProjectMasterResponse.isSuccess) {
            dispatch(setAllProjectMaster(findAllProjectMasterResponse))
            // setFilteredPhase(findAllProjectMasterResponse.data)
        } else if (findAllProjectMasterResponse.isError) {
            alertMessage("Error while fetching project masters", "error");
        }
    }, [findAllProjectMasterResponse.isSuccess, findAllProjectMasterResponse.isError]);

    useEffect(() => {
        if (allProjectMasterData) {
            if (props.reportName === REPORT_NAME.TIME_SHEET) {
                const localStorageName = localUserObj?.username ? localUserObj?.username : "";
                if (localStorageName) {
                    const isMatched = checkMentorMatch(allProjectMasterData, localStorageName);
                    setIsMentorMatched(isMatched);
                } else {
                    setIsMentorMatched(false);
                }
            }
        }
    }, [allProjectMasterData]);

    const checkMentorMatch = (allProjectMasterData: any, mentorName: any) => {
        let isMentorMatched = false;

        allProjectMasterData.forEach((project: any) => {
            if (project.projectMentors.some((mentor: any) => mentor.mentorName === mentorName)) {
                isMentorMatched = true;
            }
        });

        return isMentorMatched;
    };

    useEffect(() => {
        if (allUserGroupRespone.isSuccess) {
            dispatch(setAllUserGroup(allUserGroupRespone))
        } else if (allUserGroupRespone.isError) {
            alertMessage("Error while fetching user group", "error");
        }
    }, [allUserGroupRespone.isSuccess, allUserGroupRespone.isError]);

    useEffect(() => {
        if (allUserRoleRespone.isSuccess) {
            dispatch(setAllUserRole(allUserRoleRespone))
        } else if (allUserRoleRespone.isError) {
            alertMessage("Error while fetching user group", "error");
        }
    }, [allUserRoleRespone.isSuccess, allUserRoleRespone.isError]);

    useEffect(() => {
        if (findAllUsersResponse.isSuccess) {
            dispatch(setAllUser(findAllUsersResponse))
        } else if (findAllUsersResponse.isError) {
            alertMessage("Error while fetching users", "error");
        }
    }, [findAllUsersResponse.isSuccess, findAllUsersResponse.isError]);

    useEffect(() => {
        if (userByGroupIdResponse.isSuccess) {
            dispatch(setUserByGroupId(userByGroupIdResponse))
            setGridData([]);
        } else if (userByGroupIdResponse.isError) {
            alertMessage("Error while fetching users", "error");
        }
    }, [userByGroupIdResponse.isSuccess, userByGroupIdResponse.isError]);

    useEffect(() => {
        if (findAllKRAMasterResponse.isSuccess) {
            dispatch(setAllKRAMaster(findAllKRAMasterResponse))
        } else if (findAllKRAMasterResponse.isError) {
            alertMessage("Error while fetching key result area master", "error");
        }
    }, [findAllKRAMasterResponse.isSuccess, findAllKRAMasterResponse.isError]);

    useEffect(() => {
        if (findAllProjectPhaseActivityRes.isSuccess) {
            dispatch(setAllProjectPhaseActivity(findAllProjectPhaseActivityRes))
        } else if (findAllProjectPhaseActivityRes.isError) {
            alertMessage("Error while fetching project phase activity", "error");
        }
    }, [findAllProjectPhaseActivityRes.isSuccess, findAllProjectPhaseActivityRes.isError]);

    const handleDateChange = (startDate: any, endDate: any, setFieldValue: any) => {
        setFieldValue("planStarted", startDate)
        setFieldValue("planEnded", endDate)
    }

    const handleActualDateChange = (startDate: any, endDate: any, setFieldValue: any) => {
        setFieldValue("actualStartDate", startDate)
        setFieldValue("actualEndDate", endDate)
    }

    const handleSearchSelect = (value: any) => {
        const filteredOptions = allPhaseMasterData.filter((phase: any) =>
            phase.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredPhase(filteredOptions);
    };

    useEffect(() => {
        if (usersByGroupData && usersByGroupData.length > 0) {
            // Initialize the grid data with usernames and default user roles
            const initializedData = usersByGroupData.map((user: any, index: number) => ({
                id: index + 1,
                memberId: user.id,
                memberName: user.username,
                userRoleId: "", // Default to an empty string
                userRoleName: "", // Default to an empty string
            }));
            setGridData(initializedData);
        }
    }, [usersByGroupData]);

    const handleRoleChange = (id: any, newRole: any) => {
        const roleObj = allUserRoleData?.find((item: any) => {
            return parseInt(item.id) === parseInt(newRole);
        });

        setGridData((prevData: any) =>
            prevData.map((item: any) =>
                item.id === id ? { ...item, userRoleId: parseInt(newRole), userRoleName: roleObj.name } : item
            )
        );
    };

    // Columns for the table
    const columns = [
        {
            title: "Member Id",
            dataIndex: "memberId",
            key: "memberId"
        },
        {
            title: "Member",
            dataIndex: "memberName",
            key: "memberName",
        },
        {
            title: "Role",
            dataIndex: "role",
            key: "role",
            render: (role: any, record: any) => {
                return (
                    <select
                        className="form-select form-select-sm w-100"
                        aria-label=".form-select-sm example"
                        name="userRole"
                        value={record.userRole}
                        onChange={(e) => handleRoleChange(record.id, e.target.value)}
                    >
                        <option value="">Select Role</option>
                        {allUserRoleData && allUserRoleData.map((itemType: any) => {
                            return (
                                <option
                                    key={itemType.id}
                                    value={itemType.id}
                                >
                                    {itemType.name}
                                </option>
                            );
                        })}
                    </select>
                )
            }

        },
    ];

    const handleDateRangeChange = (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null,
        dateStrings: [string, string]) => {
        if (dates) {
            setDateRange(dates); // Set directly as Dayjs objects
            generateDateRows(dates); // Generate rows based on date range
            setShowTimeSheetGrid(true)
        } else {
            setDateRange(null); // Handle null case
        }
    };

    const generateDateRows = (dateStrings: any) => {
        if (dateStrings.length === 2) {
            const [startDateStr, endDateStr] = dateStrings;
            const startDate = new Date(startDateStr);
            const endDate = new Date(endDateStr);

            const allDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
                allDates.push(currentDate.toISOString().split('T')[0]); // Format as 'yyyy-MM-dd'
                currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
            }

            const rows = allDates.map((dateStr) => ({
                date: dateStr,
                project: null,
                activity: [],
                kra: null,
                remark: '',
                workHours: '',
                key: Date.now() + Math.random(), // Ensures unique keys
            }));

            setTimeSheetData(rows); // Set initial state with date rows
        }
    };

    const handleInputChange = (e: any, key: number, field: string) => {
        const updatedData = [...timeSheetData];
        const index = updatedData.findIndex((row) => row.key === key);
        if (index > -1) {
            updatedData[index][field] = e.target.value;
            setTimeSheetData(updatedData);
        }
    };

    const handleDropdownChange = (value: any, key: number, field: string) => {
        const updatedData = [...timeSheetData];
        const index = updatedData.findIndex((row) => row.key === key);
        if (index > -1) {
            updatedData[index][field] = value;
            setTimeSheetData(updatedData);
        }
    };

    const handleAddRow = (key: number) => {
        const updatedData = [...timeSheetData];
        const index = updatedData.findIndex((row) => row.key === key);

        if (index > -1) {
            const newRow = {
                key: Date.now(), // Unique key for the new row
                date: updatedData[index].date, // Same date as the current row
                project: null,
                activity: [],
                kra: null,
                remark: '',
                workHours: '',
            };

            // Insert the new row below the current row
            updatedData.splice(index + 1, 0, newRow);
            setTimeSheetData(updatedData);
        }
    };

    const handleRemoveRow = (key: number) => {
        setTimeSheetData(timeSheetData.filter((row) => row.key !== key)); // Remove row by key
    };

    const timeSheetColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            render: (_: any, record: any, { dateKey }: any) => (
                <span>{format(new Date(record.date), 'dd/MM/yyyy')}</span> // Use date-fns to format the date
            ),
        },
        {
            title: 'Project',
            dataIndex: 'project',
            render: (_: any, record: any, { dateKey }: any) => (
                <Select
                    className="w-100"
                    value={record.project || ""}
                    onChange={(value: any) => handleDropdownChange(value, record.key, 'project')}
                >
                    <Option value="">Select Project</Option>
                    {allProjectMasterData && allProjectMasterData.map((item: any) => (
                        <Option key={item.id} value={item.id}>
                            {item.name}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            render: (_: any, record: any, { dateKey }: any) => (
                <Select
                    // mode="multiple"
                    className="w-100"
                    value={record.activity || ""}
                    // value={record.activity || []}
                    placeholder="Select Activity"
                    onChange={(value: any) => handleDropdownChange(value, record.key, 'activity')}
                >
                    {allProjectPhaseActivityData && allProjectPhaseActivityData
                        .filter((item: any) => item.projectId === record.project)
                        .map((item: any) => (
                            <Option key={item.id} value={item.id}>
                                {item.name}
                            </Option>
                        ))}
                </Select>
            ),
        },
        {
            title: 'KRA',
            dataIndex: 'kra',
            render: (_: any, record: any, { dateKey }: any) => (
                <Select
                    className="w-100"
                    value={record.kra || ""}
                    onChange={(value: any) => handleDropdownChange(value, record.key, 'kra')}
                >
                    <Option value="">Select KRA</Option>
                    {allKRAMasterData && allKRAMasterData.map((item: any) => (
                        <Option key={item.id} value={item.id}>
                            {item.name}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: 'Remark',
            dataIndex: 'remark',
            width: 300,
            render: (_: any, record: any, { dateKey }: any) => (
                <textarea
                    className="form-control w-100 mt-5"
                    aria-label="remark field"
                    onChange={(e: any) => handleInputChange(e, record.key, 'remark')}
                    value={record.remark}
                    placeholder="Enter Remark"
                    rows={2}
                >
                </textarea>
            ),
        },
        {
            title: 'Work Hours',
            dataIndex: 'workHours',
            render: (_: any, record: any, { dateKey }: any) => (
                <Input
                    value={record.workHours}
                    onChange={(e: any) => handleInputChange(e, record.key, 'workHours')}
                    placeholder="Enter Work Hours"
                />
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_: any, record: any) => (
                <div className="d-flex">
                    <Button
                        // type="dashed"
                        onClick={() => handleAddRow(record.key)} // Add row for the same date
                        icon={<BsPlusCircle />}
                    >

                    </Button>
                    <Button
                        onClick={() => handleRemoveRow(record.key)}
                        icon={<BsDashCircle />}
                        style={{ marginLeft: 8 }}
                    >

                    </Button>
                </div>
            ),
        },
    ];

    // const onApprovalChange: GetProp<typeof Radio.Group, 'onChange'> = (e: any) => {
    //     console.log('checked = ', e.target.value);
    //     setIsApproved(e.target.value);
    // };

    const onApprovalChange = (value: string) => {
        console.log(value)
        setTimeSheetApproved((prevValue) => (prevValue === value ? null : value));
    };

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // className={props.reportName === REPORT_NAME.TIME_SHEET ? "modal-xl" : "modal-lg"}
                // dialogClassName={"modal-90w"}
                {...((props.reportName === REPORT_NAME.TIME_SHEET)
                    ? { dialogClassName: "my-modal" }
                    : { size: "lg" })}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-danger" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {saveDepartmentMasterResponse.isLoading ||
                        saveProjectMasterResponse.isLoading ||
                        saveProjectTypeMasterResponse.isLoading ||
                        savePhaseMasterResponse.isLoading ||
                        saveProjectUserMasterResponse.isLoading ||
                        saveProjectPhaseActivityResponse.isLoading ||
                        saveKRAMasterRespone.isLoading ||
                        saveTimeSheetResponse.isLoading ||
                        updateDepartmentMasterResponse.isLoading ||
                        updateProjectMasterResponse.isLoading ||
                        updateProjectTypeMasterResponse.isLoading ||
                        updatePhaseMasterResponse.isLoading ||
                        updateProjectUserMasterResponse.isLoading ||
                        updateProjectPhaseActivityResponse.isLoading ||
                        updpateKRAMasterResponse.isLoading ||
                        updateTimeSheetResponse.isLoading ||
                        getDepartmentMasterByIdResponse.isLoading ||
                        getProjectMasterByIdResponse.isLoading ||
                        getProjectTypeMasterByIdResponse.isLoading ||
                        getPhaseMasterByIdResponse.isLoading ||
                        getProjectUserMasterByIdResponse.isLoading ||
                        getProjectPhaseActivityByIdResponse.isLoading ||
                        getKRAMasterByIdResponse.isLoading ||
                        getTimeSheetByIdResponse.isLoading ||
                        findAllDepartmentMasterResponse.isLoading ||
                        findAllProjectTypeMasterResponse.isLoading ||
                        findAllPhaseMasterResponse.isLoading ||
                        findAllKRAMasterResponse.isLoading ||
                        allOrganizationsResponse.isLoading ||
                        allUserGroupRespone.isLoading ||
                        allUserRoleRespone.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}
                    <Formik
                        validationSchema={props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY ? validationSchema : ""}
                        validateOnChange={true}
                        validateOnBlur={true}
                        enableReinitialize={true}
                        initialValues={props.reportName === REPORT_NAME.DEPARTMENT_MASTER ? {
                            name: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.name
                                : "",
                            orgId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.orgId
                                : "",
                        } : (props.reportName === REPORT_NAME.PROJECT_MASTER) ? {
                            name: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.name
                                : "",
                            description: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.description
                                : "",
                            departmentId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.departmentId
                                : "",
                            orgId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.orgId
                                : "",
                            sponsor: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.sponsor
                                : "",
                            participatingOrganization: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.participatingOrganization
                                : "",
                            projectMentors: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.mentors
                                : "",
                            projectMembers: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.members
                                : "",
                            problem: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.problem
                                : "",
                            solution: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.solution
                                : "",
                            aiComponent: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.aiComponent
                                : "",
                            aiComponentDescription: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.aiComponentDescription
                                : "",
                            socialImpact: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.socialImpact
                                : "",
                            planStarted: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.planStarted
                                    ? dayjs(getByIdData.planStarted) // Convert to dayjs object if exists
                                    : null // If not, set to null to ensure no date is selected
                                : null, // For new forms, no value initially
                            planEnded: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.planEnded
                                    ? dayjs(getByIdData.planEnded) // Convert to dayjs object if exists
                                    : null // If not, set to null to ensure no date is selected
                                : null, // For new forms, no value initially
                            projectTypeId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.projectTypeId
                                : "",
                            phaseId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData?.phase || [] : [],

                        } : (props.reportName === REPORT_NAME.PROJECT_USER_MASTER) ? {
                            name: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.name
                                : "",
                            projectId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.projectId
                                : "",
                            userRoleId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.userRoleId
                                : "",
                            userGroupId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.userGroupId
                                : "",
                        } : (props.reportName === REPORT_NAME.KRA_MASTER) ? {
                            name: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.name
                                : "",
                        } : (props.reportName === REPORT_NAME.TIME_SHEET) ? {
                            userName: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.userName
                                : "",
                        } : {
                            name: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.name
                                : "",
                            activityDescription: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.activityDescription
                                : "",
                            projectCode: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.projectCode
                                : "",
                            activityCode: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.activityCode
                                : "",
                            projectMasterId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.projectId
                                : "",
                            projectTypeId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.projectTypeId
                                : "",
                            phaseId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData?.phases?.map((phase: any) => phase.phaseId) || []
                                : [],
                            userId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.userId
                                : "",
                            planStarted: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.planStartDate
                                    ? dayjs(getByIdData.planStartDate) // Convert to dayjs object if exists
                                    : null // If not, set to null to ensure no date is selected
                                : null, // For new forms, no value initially
                            planEnded: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.planEndDate
                                    ? dayjs(getByIdData.planEndDate) // Convert to dayjs object if exists
                                    : null // If not, set to null to ensure no date is selected
                                : null, // For new forms, no value initially
                            actualStartDate: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.actualStartDate
                                    ? dayjs(getByIdData.actualStartDate) // Convert to dayjs object if exists
                                    : null // If not, set to null to ensure no date is selected
                                : null, // For new forms, no value initially
                            actualEndDate: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.actualEndDate
                                    ? dayjs(getByIdData.actualEndDate) // Convert to dayjs object if exists
                                    : null // If not, set to null to ensure no date is selected
                                : null, // For new forms, no value initially
                            expectedDeliverable: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.expectedDeliverable
                                : "",
                            issue: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.issue
                                : "",
                            risk: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.risk
                                : "",
                            issueOwner: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.issueOwnerId
                                : "",
                            taskOwner: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.taskOwnerId
                                : "",
                            documentPath: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.documentPath
                                : "",
                            percentageCompleted: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.percentageCompleted
                                : 0,
                            projectStatus: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.projectStatus
                                : "",
                            kraMasterId: ACTION_TYPE.UPDATE_ACTION
                                ? getByIdData && getByIdData.kraMasterId
                                : "",
                        }}
                        onSubmit={handleSubmit}
                    >
                        {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
                            <Form>
                                {props.reportName !== REPORT_NAME.TIME_SHEET && (
                                    <div>
                                        <div className="d-flex">
                                            <div> {props.reportName} Name</div>
                                            <div style={{ color: "red" }}>*</div>
                                        </div>
                                        <input
                                            className="form-control form-control-sm w-100"
                                            type="text"
                                            aria-label=".form-control-sm example"
                                            onChange={handleChange}
                                            value={values.name}
                                            name="name"
                                        // required
                                        />
                                    </div>
                                )}
                                {props.reportName === REPORT_NAME.PROJECT_MASTER ? (
                                    <div>
                                        <div className="d-flex">
                                            <div> {props.reportName} Description</div>
                                            <div style={{ color: "red" }}>*</div>
                                        </div>
                                        <input
                                            className="form-control form-control-sm w-100"
                                            type="text"
                                            aria-label=".form-control-sm example"
                                            onChange={handleChange}
                                            value={values.description}
                                            name="description"
                                        // required
                                        />
                                    </div>
                                ) : null}
                                {props.reportName === REPORT_NAME.DEPARTMENT_MASTER ||
                                    props.reportName === REPORT_NAME.PROJECT_MASTER ? (
                                    <>
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>Organization</div>
                                            </div>
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="orgId"
                                                    value={values.orgId}
                                                >
                                                    <option value="">Select Organization</option>
                                                    {organizationData && organizationData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                {props.reportName === REPORT_NAME.PROJECT_MASTER ? (
                                    <>
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>Department</div>
                                            </div>
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="departmentId"
                                                    value={values.departmentId}
                                                >
                                                    <option value="">Select Department</option>
                                                    {allDepartmentMasters && allDepartmentMasters.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <div className="d-flex">
                                                <div>Sponsor</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.sponsor}
                                                name="sponsor"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Participating Organization</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.participatingOrganization}
                                                name="participatingOrganization"
                                            // required
                                            />
                                        </div>
                                        <div className="mt-3">
                                            <div className="d-flex">
                                                <div>Project Mentors</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.projectMentors}
                                                name="projectMentors"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Project Members</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.projectMembers}
                                                name="projectMembers"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Problem</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.problem}
                                                name="problem"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Solution</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.solution}
                                                name="solution"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Ai Component</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.aiComponent}
                                                name="aiComponent"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Ai Component Description</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.aiComponentDescription}
                                                name="aiComponentDescription"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Social Impact</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.socialImpact}
                                                name="socialImpact"
                                            // required
                                            />
                                        </div>
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>Project Type</div>
                                            </div>
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="projectTypeId"
                                                    value={values.projectTypeId}
                                                >
                                                    <option value="">Select Project Type</option>
                                                    {allProjectTypeMasterData && allProjectTypeMasterData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>Phase</div>
                                            </div>
                                            <div className="pe-2">
                                                <Select
                                                    mode="multiple"
                                                    placeholder="Select Phase"
                                                    // value={selectedPhase}
                                                    // onChange={(e)=> console.log(e)}
                                                    value={values.phaseId || []} // Use Formik's state
                                                    onChange={(value) => {
                                                        setFieldValue('phaseId', value)
                                                    }} // Update Formik's state
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    filterOption={false}
                                                    onSearch={handleSearchSelect}
                                                >
                                                    {filteredPhase && filteredPhase.map((phase: any) => {
                                                        return (
                                                            <Option key={phase.id} value={phase.id}>
                                                                <Checkbox checked={(values.phaseId).includes(phase.id)} className="me-2" />
                                                                {" "}{phase.name}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>Plan Start date and End date</div>
                                            </div>
                                            <Space direction="vertical" size={18}>
                                                <RangePicker
                                                    name="dateRange"
                                                    value={[
                                                        values.planStarted ? dayjs(values.planStarted) : null,
                                                        values.planEnded ? dayjs(values.planEnded) : null,
                                                    ]} // Pass Date objects to RangePicker
                                                    onChange={(dates: any, dateStrings: any) => {
                                                        // console.log('Selected Dates: ', dates);  // Raw date objects
                                                        // console.log('Formatted Dates: ', dateStrings);  // Formatted date strings (e.g., "YYYY-MM-DD")
                                                        // Update the state for fromDate and toDate
                                                        handleDateChange(dateStrings[0], dateStrings[1], setFieldValue);
                                                    }}
                                                />
                                            </Space>
                                        </div>
                                    </>
                                ) : (props.reportName === REPORT_NAME.PROJECT_USER_MASTER ? (
                                    <>
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>Project Master</div>
                                            </div>
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="projectId"
                                                    value={values.projectId}
                                                >
                                                    <option value="">Select Project</option>
                                                    {allProjectMasterData && allProjectMasterData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        {/* <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>User Role</div>
                                            </div>
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="userRoleId"
                                                    value={values.userRoleId}
                                                >
                                                    <option value="">Select User Role</option>
                                                    {allUserRoleData && allUserRoleData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div> */}
                                        <div className="w-100 mt-3">
                                            <div className="d-flex">
                                                <div>User Group</div>
                                            </div>
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={(e: any) => {
                                                        setFieldValue("userGroupId", e.target.value)
                                                        setShowGrid(true);
                                                        findUserByGroupId({
                                                            token: localUserObj.token,
                                                            groupId: parseInt(e.target.value)
                                                        })
                                                    }}
                                                    name="userGroupId"
                                                    value={values.userGroupId}
                                                >
                                                    <option value="">Select User Group</option>
                                                    {allUserGroupData && allUserGroupData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        {showGrid && (
                                            <div className="mt-3">
                                                <Table
                                                    columns={columns}
                                                    dataSource={gridData}
                                                    rowKey="id"
                                                    pagination={false}
                                                />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY ? (
                                        <div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Activity Description</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    aria-label="Description field"
                                                    onChange={handleChange}
                                                    value={values.activityDescription}
                                                    name="activityDescription"
                                                    rows={2}
                                                >
                                                </textarea>
                                            </div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Project Code</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.projectCode}
                                                    name="projectCode"
                                                // required
                                                />
                                            </div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Activity Code</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.activityCode}
                                                    name="activityCode"
                                                // required
                                                />
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Project Master</div>
                                                </div>
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={(e: any) => {
                                                            const selectedProjectId = e.target.value;
                                                            const selectedProject = allProjectMasterData.find(
                                                                (project: any) => project.id === parseInt(selectedProjectId)
                                                            );

                                                            if (selectedProject) {
                                                                setFieldValue('projectMasterId', selectedProject?.id);
                                                                setFieldValue('projectTypeId', selectedProject.projectTypeId ? selectedProject.projectTypeId : "");

                                                                const phaseIds = selectedProject.projectPhaseMappings.map((mapping: any) => mapping.phaseId);
                                                                setFieldValue('phaseId', phaseIds);
                                                            }
                                                        }}
                                                        name="projectMasterId"
                                                        value={values.projectMasterId}
                                                    >
                                                        <option value="">Select Project</option>
                                                        {allProjectMasterData && allProjectMasterData.map((itemType: any, index: any) => {
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.id}
                                                                >
                                                                    {itemType.id} - {itemType.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Project Type Master</div>
                                                </div>
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleChange}
                                                        name="projectTypeId"
                                                        value={values.projectTypeId}
                                                        disabled
                                                    >
                                                        <option value="">Select Project Type</option>
                                                        {allProjectTypeMasterData && allProjectTypeMasterData.map((itemType: any, index: any) => {
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.id}
                                                                >
                                                                    {itemType.id} - {itemType.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Phase</div>
                                                </div>
                                                <div className="pe-2">
                                                    <Select
                                                        mode="multiple"
                                                        placeholder="Select Phase"
                                                        value={values.phaseId || []} // Ensure it receives an array
                                                        onChange={(value) => {
                                                            setFieldValue('phaseId', value); // Update Formik's state with the new selection
                                                        }}
                                                        style={{ width: '100%' }}
                                                        disabled
                                                    >
                                                        {filteredPhase && filteredPhase.map((phase: any) => (
                                                            <Option key={phase.id} value={phase.id}>
                                                                <Checkbox checked={(values.phaseId || []).includes(phase.id)} className="me-2" />
                                                                {" "}{phase.name}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Key Result Area Master</div>
                                                </div>
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleChange}
                                                        name="kraMasterId"
                                                        value={values.kraMasterId}
                                                    >
                                                        <option value="">Select KRA Master</option>
                                                        {allKRAMasterData && allKRAMasterData.map((itemType: any, index: any) => {
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.id}
                                                                >
                                                                    {itemType.id} - {itemType.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Plan Start date and End date</div>
                                                </div>
                                                <Space direction="vertical" size={18}>
                                                    <RangePicker
                                                        name="dateRange"
                                                        value={[
                                                            values.planStarted ? dayjs(values.planStarted) : null,
                                                            values.planEnded ? dayjs(values.planEnded) : null,
                                                        ]} // Pass Date objects to RangePicker
                                                        onChange={(dates: any, dateStrings: any) => {
                                                            // console.log('Selected Dates: ', dates);  // Raw date objects
                                                            // console.log('Formatted Dates: ', dateStrings);  // Formatted date strings (e.g., "YYYY-MM-DD")
                                                            // Update the state for fromDate and toDate
                                                            handleDateChange(dateStrings[0], dateStrings[1], setFieldValue);
                                                        }}
                                                    />
                                                </Space>
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Actual Plan Start date and End date</div>
                                                </div>
                                                <div className="d-flex">
                                                    <DatePicker
                                                        placeholder="Start date"
                                                        className="mx-2 mt-2 w-50"
                                                        value={[
                                                            values.actualStartDate ? dayjs(values.actualStartDate) : null
                                                        ]} // Pass Date objects to RangePicker
                                                        onChange={(dates: any, dateString: any) => {
                                                            // console.log('Selected Dates: ', dates);  // Raw date objects
                                                            // console.log('Formatted Dates: ', dateStrings);  // Formatted date strings (e.g., "YYYY-MM-DD")
                                                            setFieldValue("actualStartDate", dateString)
                                                        }}
                                                    />
                                                    <DatePicker
                                                        placeholder="End date"
                                                        className="mx-2 mt-2 w-50"
                                                        value={[
                                                            values.actualEndDate ? dayjs(values.actualEndDate) : null
                                                        ]} // Pass Date objects to RangePicker
                                                        onChange={(dates: any, dateString: any) => {
                                                            // console.log('Selected Dates: ', dates);  // Raw date objects
                                                            // console.log('Formatted Dates: ', dateStrings);  // Formatted date strings (e.g., "YYYY-MM-DD")
                                                            setFieldValue("actualEndDate", dateString)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <div className="d-flex">
                                                    <div>Expected Deliverable</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    aria-label="Description field"
                                                    onChange={handleChange}
                                                    value={values.expectedDeliverable}
                                                    name="expectedDeliverable"
                                                    rows={2}
                                                >
                                                </textarea>
                                            </div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Issue</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.issue}
                                                    name="issue"
                                                // required
                                                />
                                            </div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Risk</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.risk}
                                                    name="risk"
                                                // required
                                                />
                                            </div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Issue Owner</div>
                                                    {/* allUsersData */}
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="issueOwner"
                                                    value={values.issueOwner}
                                                >
                                                    <option value="">Select Issue Owner</option>
                                                    {allUsersData && allUsersData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.username}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {/* <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.issueOwner}
                                                    name="issueOwner"
                                                // required
                                                /> */}
                                            </div>
                                            <div className="mt-3">
                                                <div className="d-flex">
                                                    <div>Task Owner</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleChange}
                                                    name="taskOwner"
                                                    value={values.taskOwner}
                                                >
                                                    <option value="">Select Task Owner</option>
                                                    {allUsersData && allUsersData.map((itemType: any, index: any) => {
                                                        return (
                                                            <option
                                                                key={index.toString()}
                                                                value={itemType.id}
                                                            >
                                                                {itemType.id} - {itemType.username}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {/* <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.taskOwner}
                                                    name="taskOwner"
                                                // required
                                                /> */}
                                            </div>
                                            <div>
                                                <div className="d-flex mt-3">
                                                    <div>Document Path</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.documentPath}
                                                    name="documentPath"
                                                // required
                                                />
                                            </div>
                                            <div>
                                                <div className="d-flex">
                                                    <div>Percentage Completed</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    type="number"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.percentageCompleted}
                                                    onBlur={handleBlur}
                                                    name="percentageCompleted"
                                                    className={`form-control form-control-sm w-100 
                                                    ${errors.percentageCompleted && touched.percentageCompleted
                                                            ? 'is-invalid'
                                                            : ''
                                                        }`}
                                                // required
                                                />
                                                {touched.percentageCompleted && errors.percentageCompleted && (
                                                    <div className="invalid-feedback">
                                                        {(errors.percentageCompleted).toString()}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="w-100 mt-3">
                                                <div className="d-flex">
                                                    <div>Status</div>
                                                </div>
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleChange}
                                                        name="projectStatus"
                                                        value={values.projectStatus}
                                                    >
                                                        <option value="">Select status</option>
                                                        {PROJECTIVITY_STATUS && PROJECTIVITY_STATUS.map((itemType: any, index: any) => {
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.name}
                                                                >
                                                                    {itemType.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null
                                )
                                )}
                                {props.reportName === REPORT_NAME.TIME_SHEET && (
                                    <>
                                        <div>
                                            <div className="d-flex mt-3">
                                                <div>User Name</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-50"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={props.actionType === ACTION_TYPE.ADD_ACTION ? localUserObj?.username : values.userName}
                                                name="userName"
                                            // required
                                            />
                                        </div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Select Date Range</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <RangePicker
                                                value={dateRange}
                                                onChange={handleDateRangeChange}
                                                format="YYYY-MM-DD"
                                                className="w-50"
                                                required
                                            />
                                        </div>
                                        {showTimeSheetGrid && (
                                            <div className="mt-3">
                                                <div>Sheet Data</div>
                                                {/* <Table
                                                    columns={timeSheetColumns}
                                                    dataSource={timeSheetData}
                                                    pagination={false}
                                                    rowKey="key"
                                                    className="mt-2"
                                                /> */}

                                                <Table
                                                    columns={timeSheetColumns}
                                                    dataSource={timeSheetData}
                                                    pagination={false}
                                                    rowKey="key"
                                                    className="mt-2"
                                                />
                                            </div>
                                        )}
                                        {/* <div>
                                            <div className="d-flex mt-3">
                                                <div className="me-2">Is sheet approved</div>
                                                <Radio.Group style={{ width: '50%' }} onChange={onApprovalChange}>
                                                    <Radio value="Yes">Yes</Radio>
                                                    <Radio value="No">No</Radio>
                                                </Radio.Group>
                                            </div>
                                        </div> */}
                                        {isMentorMatched && (
                                            <div className="d-flex mt-3">
                                                <div className="me-2">Is sheet approved</div>
                                                <div>
                                                    <Checkbox
                                                        checked={timeSheetApproved === "Yes"}
                                                        onChange={() => onApprovalChange("Yes")}
                                                    >
                                                        Yes
                                                    </Checkbox>
                                                    <Checkbox
                                                        checked={timeSheetApproved === "No"}
                                                        onChange={() => onApprovalChange("No")}
                                                    >
                                                        No
                                                    </Checkbox>
                                                </div>
                                            </div>
                                        )}
                                        <div>
                                            {getByIdData && props.actionType === ACTION_TYPE.UPDATE_ACTION &&
                                                <TimeSheetGraph apiResponse={getByIdData} />
                                                // <TimeSheetGraph projectGraphData={projectGraphData} kraGraphData={kraGraphData} apiResponse={getByIdData} />
                                            }
                                        </div>
                                    </>

                                )}
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        type="submit"
                                        className={`btn btn-danger btn-block mt-3 mx-2 btn-width`}
                                    >
                                        {props.actionType === ACTION_TYPE.ADD_ACTION
                                            ? "Save"
                                            : "Update"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal >
        </>
    );

};

export default MasterReportData